import TipoMontoService from "@/api/services/finanzas/nomencladores/TipoMontoService"
import Vue from "vue"
//floder
const state = () => ({
    montos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    MONTOS: state => {
        return state.montos
    },
    MONTOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_MONTOS: (state, payload) => {
        state.montos = payload
    },

    SET_MONTOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_MONTO: (state, payload) => {
        state.montos.push(payload)
    },

    UPDATE_MONTO: (state, payload) => {
        state.montos = state.montos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_MONTO: (state, payload) => {
        state.montos = state.montos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_MONTOS: async ({ commit, state }, { filter, tipoMontoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await TipoMontoService.get({ filter, tipoMontoEstado, ...pagination })
            if (status === 200) {
                commit("SET_MONTOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de monto, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_MONTOS: async ({ commit }) => {
        try {
            let { data, status } = await TipoMontoService.getAll()
            if (status === 200) {
                commit("SET_MONTOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_MONTOS: async ({ commit }) => {
        try {
            let { data, status } = await TipoMontoService.getAllRecords()
            if (status === 200) {
                commit("SET_MONTOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los tipos de monto, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_MONTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoMontoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_MONTO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del tipo de monto, inténtelo nuevamente"
            })
        }
    },

    ADD_MONTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoMontoService.post(payload)
            if (status === 201) {
                commit("ADD_MONTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El tipo de monto ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el tipo de monto, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_MONTO: async ({ commit }, payload) => {
        try {
            let { data, status } = await TipoMontoService.put(payload)
            if (status === 200) {
                commit("UPDATE_MONTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El tipo de monto ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el tipo de monto, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_MONTO: async ({ commit }, payload) => {
        try {
            let { status, data } = await TipoMontoService.delete(payload)
            if (status === 204) {
                commit("DELETE_MONTO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El tipo de monto ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_MONTO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El tipo de monto ha sido deshailitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el tipo de monto, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
